const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class EndowmentForTheArts extends Action {
    constructor(){
        super(
            Age.Age3,
            ActionNames.EndowmentForTheArts, 
            `You score culture for each civilization with more culture than your have:
            2 in a 4-player game
            3 in a 3-player game
            6 in a 2-player game`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }
}

module.exports = EndowmentForTheArts;